import { Routes } from "@angular/router";
import { authGuard } from "./auth/auth.guard";
import { TabsComponent } from "./tabs/tabs.component";
import { initCertificateStateGuard } from "./certificate/form/guards/init-certificate-state.guard";
import { CertificateState } from "./certificate/certificate.state";

export const routes: Routes = [
  {
    path: "login",
    loadComponent: () => import("./auth/login.page").then((m) => m.LoginPage),
  },
  {
    path: "register",
    loadComponent: () =>
      import("./auth/register.page").then((m) => m.RegisterPage),
  },
  {
    path: "",
    canActivate: [authGuard],
    component: TabsComponent,
    children: [
      {
        path: "company",
        loadComponent: () =>
          import("./company/company.page").then((m) => m.CompanyPage),
      },
      {
        path: "certificates",
        loadComponent: () =>
          import("./certificate/pages/certificates-types.page").then(
            (m) => m.CertificatesTypesPage,
          ),
      },
      {
        path: "certificates/:type",
        children: [
          {
            path: "",
            pathMatch: "full",
            loadComponent: () =>
              import("./certificate/pages/certificates-list.page").then(
                (m) => m.CertificatesListPage,
              ),
          },
          {
            path: "new",
            canActivate: [initCertificateStateGuard],
            providers: [CertificateState],
            loadChildren: () => import("./certificate/form/certificate-form.routes").then(m => m.certificateFormRoutes),
          },
          {
            path: "edit/:id",
            canActivate: [initCertificateStateGuard],
            providers: [CertificateState],
            loadChildren: () => import("./certificate/form/certificate-form.routes").then(m => m.certificateFormRoutes),
          },
        ],
      },
      { path: "", redirectTo: "certificates", pathMatch: "full" },
    ],
  },
  { path: "**", redirectTo: "" },
];
